import script from "./SocialLinksComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialLinksComponent.vue?vue&type=script&setup=true&lang=js"

import "./SocialLinksComponent.vue?vue&type=style&index=0&id=8e3e4106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e3e4106"]])

export default __exports__